<div class="d-flex align-items-end justify-content-between">
    <span id="ssh-login-powered-by">Powered by <a href="{{ poweredBy () }}" target='_blank' >FastX</a></span>
    <span  id="ssh-login-build-number">Build: <a href="{{ release () }}" target='_blank'>{{ build }}</a></span>
</div>